'use client';

import { signIn } from 'next-auth/react';
import { Button } from '@/components/ui/button';

export default function SsoButton() {
  function handleSsoClick() {
    void signIn('microsoft-entra-id');
  }

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleSsoClick}
      className="w-full py-2.5 font-semibold"
    >
      {/* Microsoft logo */}
      <svg width="18" height="18" viewBox="0 0 21 21" aria-hidden="true" focusable="false">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
      Continue with Microsoft
    </Button>
  );
}
